const targetCountries = [
  {
    name: "United States",
    message: "Apparel: Elk Range in the United States",
    url: "/shop/collections/anywhere/126",
  },
  {
    name: "Peru",
    message: "Apparel: Catarata del Gocta in Peru",
    url: "/shop/collections/anywhere/128",
  },
  {
    name: "Palau",
    message: "Apparel: Archipelago of Palau",
    url: "/shop/collections/anywhere/132",
  },
  {
    name: "Eswatini",
    message: "Apparel: Maletsunyane in Eswatini",
    url: "/shop/collections/anywhere/131",
  },
  {
    name: "United Arab Emirates",
    message: "Apparel: Liwa Oasis in the United Arab Emirates",
    url: "/shop/collections/anywhere/125",
  },
  {
    name: "Guatemala",
    message: "PROJECT: Long Way Home in Guatemala",
    url: "/anywhere/guatemala",
  },
  {
    name: "Ghana",
    message: "Ghana (Project coming soon)",
    url: "/coming-soon",
  },
  {
    name: "Tanzania",
    message: "PROJECT: Attractions Bird Conservation in Tanzania",
    url: "/anywhere/tanzania",
  },
  {
    name: "Honduras",
    message: "Honduras (PROJECT: Children of Soledad in Sabá, Colón)",
    url: "/anywhere/honduras",
  },
    {
    name: "Denmark",
    message: "Denmark (Project coming soon)",
    url: "/coming-soon",
  },
   {
    name: "Albania",
    message: "Albania (Project coming soon)",
    url: "/coming-soon",
  },
];

export default targetCountries;